import { Link, NavLink } from 'react-router-dom';
import './index.scss'
import LogoS from '../../assets/images/logo-rr.png'
import LogoSubtitle from '../../assets/images/logo_sub.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faHome, faUser } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedinIn, faYoutube } from '@fortawesome/free-brands-svg-icons';

const Sidebar = () => (
    <div className='nav-bar'>
        <Link className='logo' to='/'>
            <img src={LogoS} alt='logo' />
            <img className='sub-logo' src={LogoSubtitle} alt='Slogan' />
        </Link>
        <nav>
            <NavLink exact="true" activeclassName="active" to="/">
                <FontAwesomeIcon icon={faHome} color='#4d4d4e' />
            </NavLink>
            <NavLink exact="true" activeclassName="active" className="about-link" to="/about">
                <FontAwesomeIcon icon={faUser} color='#4d4d4e' />
            </NavLink>
            <NavLink exact="true" activeclassName="active" className="contact-link" to="/contact">
                <FontAwesomeIcon icon={faEnvelope} color='#4d4d4e' />
            </NavLink>
        </nav>
        <ul>
            <li>
                <a target='_blank' rel='noreferrer' href='https://www.linkedin.com/in/rudra-vashishtha-7622a3217/'>
                    <FontAwesomeIcon icon={faLinkedinIn} color='#00a0dc' />
                </a>
            </li>
            <li>
                <a target='_blank' rel='noreferrer' href='https://github.com/rudravashishtha'>
                    <FontAwesomeIcon icon={faGithub} color='#E5E5E5' />
                </a>
            </li>
            <li>
                <a target='_blank' rel='noreferrer' href='https://www.youtube.com/channel/UC3mhM7h8--dcoGNMNqY6zZA'>
                    <FontAwesomeIcon icon={faYoutube} color='#ff3333' />
                </a>
            </li>
        </ul>
    </div>
)


export default Sidebar;